module.exports = __webpack_public_path__ + "static/media/sparkle.e3efcf32.svg";